module.exports = __webpack_public_path__ + "static/media/instagram.8b55a1b5.svg";